export default __webpack_public_path__ + "static/media/dots.387d4b0a.svg";